import { Link } from "react-router-dom";
import { siteConfig } from "@/mocks/site";

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="container-site grid grid-cols-1 gap-10 py-12 md:grid-cols-4 md:py-14">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-archive-2-line text-lg"></i>
            </span>
            <span className="font-heading text-lg font-bold text-foreground-900">
              {siteConfig.name}
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-6 text-foreground-600">
            {siteConfig.description}
          </p>
          <div className="mt-5 flex flex-wrap items-center gap-2">
            <span className="chip">
              <i className="ri-stack-line mr-1"></i>
              合集
            </span>
            <span className="chip">
              <i className="ri-list-unordered mr-1"></i>
              索引
            </span>
            <span className="chip">
              <i className="ri-archive-line mr-1"></i>
              归档
            </span>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground-900">站内导航</h4>
          <ul className="mt-4 space-y-2.5">
            {siteConfig.nav.map((item) => (
              <li key={item.key}>
                <Link
                  to={item.path}
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground-900">资源分类</h4>
          <ul className="mt-4 space-y-2.5">
            {siteConfig.categories.slice(0, 6).map((c) => (
              <li key={c.key}>
                <Link
                  to={`/collections?cat=${c.key}`}
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="container-site flex flex-col items-center justify-between gap-2 py-5 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} {siteConfig.name} 保留所有权利。</p>
          <p className="flex items-center gap-2">
            <i className="ri-mail-line"></i>
            {siteConfig.email}
          </p>
        </div>
      </div>
    </footer>
  );
}